import { Wrapper, Status } from '@googlemaps/react-wrapper';

import Map from './Map';
import Spinner from './Spinner';
import Error from './Error';

const render = (status: Status): JSX.Element => {
  if (status === Status.FAILURE) return <Error />;
  return <Spinner />;
};

const MapWrapper = (): JSX.Element => {
  return (
    <>
      <Wrapper
        apiKey={process.env.googleMapsKey as string}
        render={render}
        libraries={['geometry', 'places']}
      >
        <Map />
      </Wrapper>
    </>
  );
};

export default MapWrapper;
